import React from 'react';
import {Component} from 'react';
import './css/styles.css';
import Header from './components/shared-components/header';
import LoginForm from './components/login-related/login-form';
import LogoutForm from './components/login-related/logout-form';
import Footer from './pages/footer';
import HomePage from './pages/homepage';
import Administration from './pages/administration';
import GettingStartedDetailed from './pages/gettingStartedDetailed';
import SpecialProcesses from './pages/specialProcesses';
import GameView from './pages/gameView';
import ExtraCredit from './pages/extraCredit';
import ForParents from './pages/forParents';
import AboutPage from './pages/aboutPage';
import ContactUs from './pages/contactUs';
import Activities from './pages/activities';
import SpecialActivity from './pages/specialActivity';
import MoneyBuilder from './pages/moneyBuilder';
import createPortal from './components/login-related/create_portal';
import { appRoutes } from "./datasets/app_routes";
import {UsernameContext} from './objects/Context/username_context';
import updateSessionTokenStorage from './pages/Objects/update_session_token_storage';
import AppInitializer from './components/appInitializer';
import withRouterCompat from './objects/CommonUse/with_router_compat';
//import {LoginContext} from './objects/Context/login_context';

import './App.css';
import {
  Routes,
  Route
} from "react-router-dom";

const componentMap = {
  AboutPage,
  Activities,
  Administration,
  ContactUs,
  ExtraCredit,
  ForParents,
  GameView,
  GettingStartedDetailed,
  HomePage,
  MoneyBuilder,
  SpecialActivity,
  SpecialProcesses,
  createPortal,
};

class App extends Component {
  constructor(props)
  {
    super(props);
      this.loginRef = React.createRef();
      this.state = {
          displayLoginMenu: false,
          username: "",
          loggedIn: false,
          userRole: "",
          appInitialized: false,
          authChecked: false,
          nextProcess: "",
          screenSize: "",
      };
      console.log("Main App");
     
  }
  
  render() {  
   //   console.log("!!!selected path: ", window.location.pathname);
    
  return (
     <div id="container">
     <meta name="description" content="Financial LIteracy is an important life skill.  For many, the
        best practices of managing money are learned through costly mistakes.  This site offers
        a different approach.  Click on this link to explore a game that will teach basic financial
        literacy concepts through an experiential game." />
      <UsernameContext.Provider value={this.state}>
          <Header toggleLoginMenu={() => this.toggleLoginMenu()} 
              username={this.state.username}
              userRole={this.state.userRole} 
              userLoggedIn={this.state.loggedIn}
              openLoginMenu={(loginObj)=> this.openLoginMenu(loginObj)}
              onClick={this.handleOutsideClick}
          />
          
         <div ref={this.loginRef}>
            {this.state.displayLoginMenu ? (
                !this.state.loggedIn ?
                    <LoginForm 
                      loginObj = {this.loginObj}
                      onSuccessfulLogin={this.loginCallback}/>
                :
                    <LogoutForm onLogout={this.logoutCallback} username={this.state.username}/>
            ) : null}
        </div>

       
      {/* Only initialize app after login */}
      {!this.state.authChecked ? (
                <div>Loading...</div>
            ) : this.state.loggedIn && !this.state.appInitialized ? (
                <AppInitializer onComplete={this.startProcess} />
            ) : (
                 <div className="main-content">    
                  <Routes>
                    {appRoutes.map(({ path, component, selected }) => {
                      const Component = componentMap[component];

                      return (
                        <Route
                          key={path}
                          path={path}
                          element={
                            component === "HomePage" ? (
                              <Component
                                selected={selected}
                                openLoginMenu={this.openLoginMenu}
                                onSuccessfulLogin={this.loginCallback}
                              />
                            ) : (
                              <Component selected={selected} />
                            )
                          }
                        />
                      );
                    })}
                  </Routes>
                </div>
      )}
      {/* only display the footer if not an ipad and not zoom */}
      {!["zoom"].includes(this.state.screenSize) && <Footer/>}
        </UsernameContext.Provider>
    </div>
  );
  }


componentDidMount() {
    document.addEventListener("mousedown", this.handleOutsideClick);
    const screenSize = sessionStorage.getItem("GameScreenSize");
    this.setState({ screenSize: screenSize || "wide" });
    const checkAuthToken = updateSessionTokenStorage("", true);
    const username = sessionStorage.getItem('username');
    const userRole = sessionStorage.getItem('userRole');
    if (checkAuthToken.tokenIsValid) {
        this.setState({
            username: username,
            userRole: userRole,
            loggedIn: true,
            nextProcess: checkAuthToken.authTokenObj.process,
            authChecked: true
        });
    } else {
        this.setState({ authChecked: true });
    }
}

componentWillUnmount(){
      document.removeEventListener("mousedown", this.handleOutsideClick);
}

handleOutsideClick = (event) => {
    if (
        this.state.displayLoginMenu &&
        this.loginRef.current &&
        !this.loginRef.current.contains(event.target)
    ) {
        this.setState({ displayLoginMenu: false });
    }
};

  toggleLoginMenu()
  {
    this.setState({displayLoginMenu: !this.state.displayLoginMenu});
  }

  openLoginMenu = (loginObj) => {
    this.loginObj = loginObj;
    this.setState({ displayLoginMenu: true });
  }


  loginCallback = (username, userRole) =>
  {
      //  this throws an error because it is being called from the render of the login_form process
      //  but changing to direct assignments does not seem to work consistently. 
      this.setState({username: username, displayLoginMenu: false, loggedIn: true, userRole: userRole});
      console.log("user logged in by form");
  }

  logoutCallback = () =>
  {
    sessionStorage.removeItem('sessionToken');
    sessionStorage.removeItem('username');
    sessionStorage.removeItem("userRole"); 
    this.setState({username: "", displayLoginMenu: false, loggedIn: false, userRole: "", 
       appInitialized: false});
    console.log("logoutCallback");
  }

  startProcess = () => 
  {
    this.setState({appInitialized: true});
    this.onNavigate(this.state.nextProcess);
  }

  onNavigate = (path) => {
      const { navigate, location } = this.props;
      // Only navigate if we aren’t already there
      if (location.pathname !== path) {
          navigate(path, { replace: true });
      }
  };
}

export default withRouterCompat(App);
